import { createContext, useCallback, useContext, useState } from "react";
import FullscreenModal from "../components/FullscreenModal";

const ModalContext = createContext(null);

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
    const [modalState, setModalState] = useState({
        open: false,
        title: "",
        content: null,
        footer: null,
        navigateOnClose: null,
        size: "lg",
        fullscreen: true,
        requireConfirmOnClose: true,
    });

    const openModal = useCallback(({ title = "", content = null, footer = null, navigateOnClose = null, size = "lg", fullscreen = true, requireConfirmOnClose = true }) => {
        setModalState({ open: true, title, content, footer, navigateOnClose, size, fullscreen, requireConfirmOnClose });
    }, []);

    const closeModal = useCallback(() => {
        setModalState((s) => ({ ...s, open: false }));
    }, []);

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            {children}
            <FullscreenModal
                show={modalState.open}
                onHide={closeModal}
                title={modalState.title}
                footer={modalState.footer}
                navigateOnClose={modalState.navigateOnClose}
                size={modalState.size}
                fullscreen={modalState.fullscreen}
                requireConfirmOnClose={modalState.requireConfirmOnClose}
            >
                {modalState.content}
            </FullscreenModal>
        </ModalContext.Provider>
    );
};

export default ModalContext;
